import { render, staticRenderFns } from "./addtoshopButton.vue?vue&type=template&id=f57b5254&scoped=true&"
import script from "./addtoshopButton.vue?vue&type=script&lang=js&"
export * from "./addtoshopButton.vue?vue&type=script&lang=js&"
import style0 from "./addtoshopButton.vue?vue&type=style&index=0&id=f57b5254&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57b5254",
  null
  
)

export default component.exports